import React from "react";
import biat from "./files/logo_biat.jpg";
import ancom from "./files/logo_ancom.jpg";
import styles from "./partners.module.css";

class PartnersSlide extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          //height: "77vh",
          height: "42.3em",
          width: "98.5%"
        }}
      >
        <div className={styles.companyContainer} style={{ flex: "12" }}>
          <div>
            <a href="http://www.mntc-biat.ru" target="_blank" rel="noopener noreferrer">
              <img
                src={biat}
                style={{
                  width: "8.3em",
                  height: "auto"
                }}
                alt="БИАТ"
              />
            </a>
          </div>
          <div style={{ paddingLeft: "1vw" }}>
            <div style={{ fontWeight: "600", fontSize: "0.92vw" }}>
              ООО Многопрофильный научно-технический центр «БИАТ»
            </div>
            <div style={{ paddingTop: "1.6em" }}>
              Организован в январе 1992г на базе отдела Центрального
              научно-исследовательского института комплексной автоматизации
              (ЦНИИКА) и имеет многолетний опыт системной интеграции,
              проектирования, внедрения и сопровождения автоматизированных
              систем управления технологическими процессами в химической,
              нефтехимической, газовой промышленности и автоматизированных
              систем коммерческого и технического учёта энергоносителей в
              энергетике, жилищно-коммунальном хозяйстве и на промышленных
              предприятиях.
            </div>
          </div>
        </div>
        <div style={{ flex: "1" }} />
        <div
          className={styles.companyContainer}
          style={{
            //marginTop: "1.5vh",
            flex: "12"
          }}
        >
          <div>
            <a href="http://www.analytic.ru" target="_blank">
              <img src={ancom} style={{ width: "8.3em", height: "auto" }} />
            </a>
          </div>
          <div style={{ paddingLeft: "1vw" }}>
            <div style={{ fontWeight: "600", fontSize: "0.92vw" }}>
              ООО «Аналитик ТелекомСистемы»
            </div>
            <div style={{ paddingTop: "1.6em" }}>
              Компания создана в 1992 году. Основным направлением деятельности
              является разработка и производство телекоммуникационного
              оборудования, а также средств измерений систем связи под торговой
              маркой AnCom. Приборы получили широкое распространение в различных
              отраслях экономики.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PartnersSlide;
